import { useState } from 'react'
import type { SchemaNovelShow } from 'api'

import {
  Wrapper,
  VideoName,
  BookDecoration,
  BookDecorationItem1,
  BookDecorationItem2,
  StyledAesImage,
  VideoTags,
  VideoInfo,
  VideoNameWhite,
  // VideoInfoOnTop,
  // VideoInfoOnTopBackground,
  // VideoNameWhite
} from './Styled'
import { useSelector } from 'react-redux'
import { selectStation } from 'redux/selector/app'
import { useNavigateTo } from 'hooks/useNavigateTo'

interface NovelInfo {
  novelInfo: SchemaNovelShow
  columns?: number
  width?: string
  titleInSlide?: boolean
  noDecoration?: boolean
  overflow?: any
  noLazy?: boolean
  allowUnload?: boolean
  hideTags?: boolean
  fontSize?: string | number
  [key: string]: any
}

/**
 * 元件 - 影片 Item
 */
export default function NovelBox({
  novelInfo,
  width,
  columns = 2,
  overflow,
  titleInSlide = false,
  noDecoration = false,
  noLazy = false,
  allowUnload = true,
  hideTags = false,
  fontSize,
  ...props
}: NovelInfo) {
  const { navigateToNovel } = useNavigateTo()
  const station = useSelector(selectStation)

  const { title, tag_names = [], cover_url } = novelInfo

  const [blobs, setBlobs] = useState<Blob[]>([])

  const onVideoBoxClick = async () => {
    let posterImg: string | undefined
    const imgBlob = blobs[0]
    if (imgBlob) {
      posterImg = await new Promise<string | undefined>((resolve) => {
        const reader = new FileReader()
        reader.readAsDataURL(imgBlob)
        reader.onload = () => {
          resolve(typeof reader.result === 'string' ? reader.result : undefined)
        }
      })
    }
    navigateToNovel({
      posterImg,
      novelInfo: {
        ...novelInfo,
      },
    })
  }

  return (
    <Wrapper {...props} onClick={onVideoBoxClick} width={width} columns={columns}>
      {!noDecoration && (
        <BookDecoration>
          <BookDecorationItem1 />
          <BookDecorationItem2 />
        </BookDecoration>
      )}
      <StyledAesImage
        source="novel"
        decryptKey={station.cover_key}
        aspectRatio={1 / 1.414}
        src={cover_url}
        onImageBlobsLoad={setBlobs}
        noLazy={noLazy}
        allowUnload={allowUnload}
      />

      <VideoInfo>
        {!titleInSlide && <VideoName>{title}</VideoName>}
        {titleInSlide && <VideoNameWhite fontSize={fontSize}>{title}</VideoNameWhite>}
        {/* limit visible tag to 2 tags */}
        {!hideTags && tag_names.length > 0 && <VideoTags>{tag_names.slice(0, 2).join(' ')}</VideoTags>}
      </VideoInfo>
    </Wrapper>
  )
}
